import useTheme from 'branding/theme';
const useSectionMargin = ({ margin, marginHorizontal, marginVertical, marginTop, marginBottom, marginLeft, marginRight }) => {
    const { sizing: { section: sectionSizing } } = useTheme();
    return {
        ...(margin && { margin: sectionSizing.margin[margin] }),
        ...(marginHorizontal && {
            marginLeft: sectionSizing.margin[marginHorizontal],
            marginRight: sectionSizing.margin[marginHorizontal]
        }),
        ...(marginVertical && {
            marginTop: sectionSizing.margin[marginVertical],
            marginBottom: sectionSizing.margin[marginVertical]
        }),
        ...(marginTop && { marginTop: sectionSizing.margin[marginTop] }),
        ...(marginBottom && { marginBottom: sectionSizing.margin[marginBottom] }),
        ...(marginLeft && { marginLeft: sectionSizing.margin[marginLeft] }),
        ...(marginRight && { marginRight: sectionSizing.margin[marginRight] })
    };
};
export default useSectionMargin;
//# sourceMappingURL=index.js.map